import CryptoJS from "crypto-js";
import { sha512 } from "js-sha512";

const encryptedBase64Key = import.meta.env?.VITE_ENCRYPTED_KEY;
const parsedBase64Key = CryptoJS.enc.Base64.parse(encryptedBase64Key);

export const encoded = (plaintext) => {
  return CryptoJS.AES.encrypt(plaintext, parsedBase64Key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  }).toString();
};

export const decoded = (encryptedText) => {
  return JSON.parse(
    CryptoJS.AES.decrypt(encryptedText, parsedBase64Key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    }).toString(CryptoJS.enc.Utf8)
  );
};

export const getSha = (password) => {
  if (!password || typeof password !== "string") return "";
  return sha512(password);
};

// Constants
export const toastConfig = {
  autoClose: 2000,
  hideProgressBar: true,
  removalReason: "timeout"
};